"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParticipantFilter = void 0;
var _react = require("react");
var _reactUi = require("@100mslive/react-ui");
var _reactIcons = require("@100mslive/react-icons");
var _utils = require("../../common/utils");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ParticipantFilter = function ParticipantFilter(_ref) {
  var _selection$metadata, _selection$metadata2;
  var selection = _ref.selection,
    onSelection = _ref.onSelection,
    isConnected = _ref.isConnected,
    roles = _ref.roles;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var selectionValue = (selection === null || selection === void 0 ? void 0 : selection.role) || (selection !== null && selection !== void 0 && (_selection$metadata = selection.metadata) !== null && _selection$metadata !== void 0 && _selection$metadata.isHandRaised ? "Raised Hand" : "");
  var onItemClick = (0, _react.useCallback)(function (value) {
    onSelection(value);
    setOpen(false);
  }, []); //eslint-disable-line
  if (!isConnected) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Root, {
    open: open,
    onOpenChange: function onOpenChange(value) {
      return setOpen(value);
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Trigger, {
      asChild: true,
      "data-testid": "participant_list_filter",
      css: {
        border: "1px solid $textDisabled",
        r: "$0",
        p: "$2 $4"
      },
      tabIndex: 0,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        align: "center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          css: _objectSpread({}, (0, _reactUi.textEllipsis)(80)),
          children: selectionValue || "Everyone"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
          css: {
            ml: "$2",
            color: "$textDisabled"
          },
          children: open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronUpIcon, {
            width: 14,
            height: 14
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronDownIcon, {
            width: 14,
            height: 14
          })
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Content, {
      align: "start",
      sideOffset: 8,
      css: {
        height: "auto",
        maxHeight: "$96",
        boxShadow: "$md",
        w: "$48"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Item, {
        selected: !selection,
        title: "Everyone",
        onSelection: onItemClick,
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PeopleIcon, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Item, {
        selected: selection === null || selection === void 0 ? void 0 : (_selection$metadata2 = selection.metadata) === null || _selection$metadata2 === void 0 ? void 0 : _selection$metadata2.isHandRaised,
        title: "Raised Hand",
        onSelection: onItemClick,
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.HandRaiseIcon, {}),
        value: {
          metadata: {
            isHandRaised: true
          },
          role: ""
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.ItemSeparator, {}), roles.filter(function (role) {
        return !(0, _utils.isInternalRole)(role);
      }).map(function (role) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(Item, {
          selected: selectionValue === role,
          title: role,
          value: {
            metadata: {
              isHandRaised: false
            },
            role: role
          },
          onSelection: onItemClick
        }, role);
      })]
    })]
  });
};
exports.ParticipantFilter = ParticipantFilter;
var Item = function Item(_ref2) {
  var selected = _ref2.selected,
    title = _ref2.title,
    onSelection = _ref2.onSelection,
    value = _ref2.value,
    icon = _ref2.icon;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
    onClick: function onClick(e) {
      e.preventDefault();
      onSelection(value);
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      align: "center",
      css: {
        flex: "1 1 0"
      },
      children: [icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        children: icon
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        css: {
          ml: "$4"
        },
        children: title
      })]
    }), selected && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CheckIcon, {
        widht: 16,
        height: 16
      })
    })]
  });
};